/* Trapezoid sector patch for the option pills, matching the feature cards:
   rounded corners, sides converge along the fan's radial lines. Shared by
   all pills in the local, pre-rotation frame; colors come from CSS vars on
   the parent button. */
export function HomeOptionShape({ glow = false }: { glow?: boolean }) {
  return (
    <svg className={glow ? "ce-home-option-shape ce-home-option-shape--glow" : "ce-home-option-shape"} viewBox="0 0 136 52" preserveAspectRatio="none" aria-hidden="true">
      {/* Top-edge bulge must peak at y >= half the stroke width (0.55): the svg viewport clips content above y=0, and a control point with negative y makes the outline fade out mid-edge ("描边渐变"). */}
      <path vectorEffect="non-scaling-stroke" d="M 9 2.2 Q 68 -0.8 127 2.2 Q 135 2.6 134 9.5 L 131.6 42.5 Q 131 50.8 122.5 51.2 Q 68 48.7 13.5 51.2 Q 5 50.8 4.4 42.5 L 2 9.5 Q 1 2.6 9 2.2 Z" />
    </svg>
  );
}
